<style lang="scss" scoped>
.page-intelligent {
    .c-datetime-range {
        max-width: 256px !important;
    }
    .map-container  {
        position: relative;
        border: 1px solid #eee;
        padding: 0px;
        margin: 0px;
        width: 100%;
        height: 650px;
    }
    .device-time {
        display: block;
        position: absolute;
        top: 5px;
        left: 45px;
        z-index: 10;
        background: rgba(255, 255, 255, .3);
        padding: 8px 12px;
        border-radius: 2px;
        box-shadow: 0 0 3px rgba(0,0,0,.5);
        font-size: 12px;
    }
    /deep/ .device-searchs {
        display: block;
        position: absolute;
        top: 5px;
        left: 280px;
        z-index: 10;
        background: rgba(255, 255, 255, .3);
        padding: 1.5px;
        border-radius: 2px;
        box-shadow: 0 0 2px rgba(0,0,0,.5);
        font-size: 12px;
        .search-input {
            width: 120px;
            .el-input__inner {
                padding-left: 6px;
            }
        }
    }
    .total-count {
        display: block;
        position: absolute;
        top: 5px;
        right: 40px;
        z-index: 10;
        background-color: #ffffff;
        padding: 6px 12px;
        border-radius: 2px;
        box-shadow: 0 0 3px rgba(0,0,0,.5);
    }
    .full-screen, .order-switch, .order-mousetools, .point-list-btn, .selected-list-btn {
        display: block;
        position: absolute;
        top: 5px;
        right: 5px;
        z-index: 10;
        background-color: #ffffff;
        padding: 2px;
        border-radius: 2px;
        box-shadow: 0 0 3px rgba(0,0,0,.5);
        cursor: pointer;
        .el-icon-full-screen {
            font-size: 26px;
        }
    }
    .full-screen:hover, .order-switch:hover, .order-mousetools .btn:hover, .point-list-btn:hover, .selected-list-btn:hover {
        background-color: #f0f0f0;
    }
    .order-switch {
        top: 42px;
        right: 40px;
        padding: 4px;
        .el-icon-turn-off {
            font-size: 22px;
        }
    }
    .order-switch-open {
        background: rgba(121, 184, 255, 1);
        .el-icon-open {
            font-size: 22px;
            color: #ffffff;
        }
    }
    .order-switch-open:hover {
        background: rgba(121, 184, 255, 1);
    }
    .order-mousetools {
        top: 42px;
        right: 75px;
        padding: 0;
        .btn {
            display: block;
            float: right;
            padding: 4px;
            i {
                font-size: 22px;
            }
        }
        .btn-open, .btn-open:hover {
            background: rgba(121, 184, 255, 1);
            i {
                color: #ffffff;
            }
        }
        .btn-actived {
            i {
                color: #79b8ff;
            }
        }
    }
    .point-list-btn {
        left: 5px;
        right: auto;
        top: 5px;
        font-size: 24px;
        padding: 0 3px;
    }
    .cluster-list {
        padding: 10px 12px;
        border-bottom: 1px dashed #eee;
        .cluster-item {
            margin-top: 3px;
        }
    }
    .cluster-list:hover {
        background-color: #f5f5f5;
    }
    /deep/ .point-box {
        position: absolute;
        top: 45px;
        left: 5px;
        width: 500px;
        height: auto;
        z-index: 10;
        background: #fff;
        .el-table--border {
            border-top: 0;
        }
        .el-tabs__content {
            padding: 0 !important;
        }
        .el-table__body-wrapper {
            max-height: 470px;
            overflow-y: auto;
        }
        .point-btn {
            font-size: 14px;
            padding: 4px;
        }
    }
    /deep/ .map-screen {
        margin: 0;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 999;
        .point-box {
            .el-table__body-wrapper {
                max-height: calc(82vh - 40px);
                overflow-y: auto;
            }
        }
    }
    .selected-list-btn {
        display: block;
        right: 5px;
        top: 42px;
        font-size: 24px;
        padding: 0 3px;
    }
    /deep/ .selected-box {
        position: absolute;
        top: 76px;
        right: 4px;
        width: 220px;
        height: auto;
        z-index: 10;
        background: #fff;
        .el-table__body-wrapper {
            max-height: 400px;
            overflow-y: auto;
        }
        .point-btn {
            font-size: 14px;
            padding: 4px;
        }
    }
    /deep/ .row-highlight {
        td {
            background: #badaff;
        }
    }
}
</style>
<style>
.point-blue {
    display: inline-block; width: 10px; height: 10px; background: #4b9efc; border-radius: 10px;
}
.point-red {
    display: inline-block; width: 10px; height: 10px; background: #ff0000; border-radius: 10px;
}
</style>
<template>
    <div class="page-intelligent">
        <div class="toolbars mrgb10">
            <div class="buttons mrgb5">
                <div class="fl">
                    <el-tooltip effect="dark" content="更新当前实时分析数据，可获取到最新配置点位的车辆数据。" placement="top">
                        <el-button class="mrgb5" type="primary" size="medium" @click="_updateData()"><i class="fa fa-refresh"></i> 更新数据</el-button>
                    </el-tooltip>
                    <el-button class="mrgb5" type="warning" size="medium" @click="openConfig()"><i class="fa fa-edit"></i> 配置点位</el-button>
                </div>
                <div class="fr">
                    <el-date-picker class="mrgr5 mrgb5" v-model="selectedDate" @change="initLoadData()"
                        type="date" size="medium" placeholder="请选择日期">
                    </el-date-picker>
                    <el-time-select class="c-el-input mrgr5 mrgb5" v-model="selectedStartTime" size="medium" 
                        @change="selectTime" placeholder="选择查询时间点" :editable="false"
                        :picker-options="{
                            start: '00:00',
                            step: '00:30',
                            end: '23:30'
                        }"
                    ></el-time-select>
                    <el-button type="primary" size="medium" @click="initLoadData()"><i class="fa fa-search"></i> 查询</el-button>
                    <el-tooltip effect="dark" placement="top">
                        <div slot="content">
                            注：每{{ spaceTime }}分钟更新一次实时车辆数据。<br />
                            车辆定位：仅代表【{{ deviceItem.time }}】之前的车辆实时定位。<br />
                            通过配置点位，可查看点位附近的车辆情况，可参考提示的缺车、淤积情况做出相应的工作指导。<br />
                        </div>
                        <el-tag class="mrgl5" type="warning" size="medium"><i class="el-icon-view f12"></i> 查看说明</el-tag>
                    </el-tooltip>
                </div>
                <div class="clearb"></div>
                <div>
                    <el-button-group>
                        <template v-for="(item, time) in pointTimes">
                            <el-button type="primary" size="medium" v-if="time % 2 === 0"
                                :plain="selectedStartTime !== item"
                                :key="item" @click="selectTime(item)">{{ time / 2 }}时</el-button>
                        </template>
                    </el-button-group>
                </div>
            </div>
        </div>
        <div class="map-container" :class="isScreen ? 'map-screen' : ''" id='mapDeviceScreen'>
            <span class="device-time">数据更新时间：{{ deviceItem.time }}</span>
            <span class="device-searchs" v-if="deviceItem.time">
                <el-input v-model="searchVehicleNumber" class="search-input" placeholder="车辆号搜索" size="mini" @change="searchVehicle()"></el-input>
                <el-button class="mrgl5" type="primary" size="mini" @click="searchVehicle()">查询</el-button>
            </span>
            <span class="total-count col_primary" title="当前查询出的总车辆数">总数量：{{ deviceItem.gps && deviceItem.gps.length || 0 }}</span>
            <span class="full-screen" :title="!isScreen ? '全屏' : '还原'" @click="isScreen = !isScreen">
                <i class="el-icon-full-screen"></i>
            </span>
            <el-tooltip :content="isOrderSwitchOpen ? '点击隐藏订单车辆点位' : '点击显示订单车辆点位'" placement="top-end">
                <span class="order-switch" @click="orderSwitch()" 
                    :class="isOrderSwitchOpen ? 'order-switch-open' : ''" >
                    <i class="el-icon-open" v-if="isOrderSwitchOpen"></i>
                    <i class="el-icon-turn-off" v-else></i>
                </span>
            </el-tooltip>
            <span class="order-mousetools">
                <el-tooltip :content="isChooseVehicleOpen ? '结束选车' : '开始选车'" placement="top-end">
                    <span class="btn" :class="isChooseVehicleOpen ? 'btn-open' : ''"
                        @click="chooseSwitch()"><i :class="isChooseVehicleOpen ? 'el-icon-crop' : 'el-icon-crop'"></i></span>
                </el-tooltip>
                <template v-if="isChooseVehicleOpen">
                    <el-tooltip content="矩形选车" placement="top-end">
                        <span class="btn" :class="chooseType === chooseTypeArray[0] ? 'btn-actived' : ''"
                            @click="chooseVehicleType(chooseTypeArray[0])"><i class="el-icon-menu"></i></span>
                    </el-tooltip>
                    <el-tooltip content="圆形选车" placement="top-end">
                        <span class="btn" :class="chooseType === chooseTypeArray[1] ? 'btn-actived' : ''"
                            @click="chooseVehicleType(chooseTypeArray[1])"><i class="el-icon-bangzhu"></i></span>
                    </el-tooltip>
                    <el-tooltip :content="isChooseVehicleStatus ? '正在新增车辆' : '正在移除车辆'" placement="left-start">
                        <span class="btn"
                            @click="chooseVehicleStatus()"><i :class="isChooseVehicleStatus ? 'el-icon-plus' : 'el-icon-minus'"></i></span>
                    </el-tooltip>
                </template>
            </span>
            <template v-if="pointGroups.length > 0">
                <span class="point-list-btn" @click="isShowFold = !isShowFold" :title="isShowFold ? '点位列表收起' : '点位列表展开'">
                    <i :class="isShowFold ? 'el-icon-s-fold' : 'el-icon-s-unfold'"></i>
                </span>
                <div class="point-box" v-if="isShowFold">
                    <el-tabs v-model="activeIndex" type="border-card" @tab-click="handleGroupClick">
                        <el-tab-pane :label="tag.category || '未分类'" :name="tindex.toString()" v-for="(tag, tindex) in pointGroups" :key="'tab-' + tindex">
                            <el-table :data="tag.items" border size="small"
                                :row-class-name="tableRowClassName"
                                @row-click="rowClick">
                                <el-table-column label="点位名称" >
                                    <template slot-scope="scope">
                                        {{ scope.row.name }}
                                        <span class="curp" title="查看经纬度" @click.stop="viewLocation(scope.row)"><i class="el-icon-view col_primary"></i></span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="车辆数" width="65">
                                    <template slot-scope="scope">
                                        <span class="col_primary">{{ scope.row.vehicleCount }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column width="100" v-if="nextTitle">
                                    <template slot="header">
                                        <el-tooltip effect="dark" content="下个高峰期的开始时间" placement="top-start">
                                            <span>{{ nextTitle }}<i class="el-icon-question f14 col_warning mrgl5"></i></span>
                                        </el-tooltip>
                                    </template>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.nextDemandItem && scope.row.nextDemandItem.demandVehicleCount || 0 }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="挪车需求" width="96">
                                    <template slot="header">
                                        <el-tooltip effect="dark" content="建议挪车数量" placement="top-start">
                                            <span>挪车需求<i class="el-icon-question f14 col_warning mrgl5"></i></span>
                                        </el-tooltip>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-tooltip effect="dark" content="请补充车辆" placement="right" v-if="scope.row.diffValue > 0">
                                            <el-tag effect="dark" type="danger" size="mini">+{{ scope.row.diffValue }}</el-tag>
                                        </el-tooltip>
                                        <el-tooltip effect="dark" content="请减少车辆" placement="right" v-else-if="scope.row.diffValue < 0">
                                            <el-tag effect="dark" type="success" size="mini">{{ scope.row.diffValue }}</el-tag>
                                        </el-tooltip>
                                        <el-tag type="info" size="mini" v-else>{{ scope.row.diffValue }}</el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column label="全部" width="60" v-if="nextTitle">
                                    <template slot-scope="scope">
                                        <el-button slot="reference" class="point-btn mrgl5" type="primary" size="mini" plain @click.stop="getCurrentDemand(scope.row)"><i class="el-icon-time"></i></el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </template>
            <div>
                <span class="selected-list-btn" @click="isShowSelectedFold = !isShowSelectedFold" :title="isShowSelectedFold ? '车辆选择列表收起' : '车辆选择列表展开'">
                    <i :class="!isShowSelectedFold ? 'el-icon-s-fold' : 'el-icon-s-unfold'"></i>
                </span>
                <div class="selected-box" v-if="isShowSelectedFold">
                    <el-table :data="selectedVehicles" border size="small" highlight-current-row>
                        <el-table-column label="" width="50">
                            <template slot-scope="scope">
                                {{ ++scope.$index }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="carId" label="车辆号"></el-table-column>
                        <el-table-column label="操作" width="65">
                            <template slot-scope="scope">
                                <el-button class="point-btn" type="danger" size="mini" plain @click.stop="deleteChoose(scope.row, scope.$index)"><i class="el-icon-delete"></i></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="tc">
                        <el-button class="mrgt5 mrgb5" type="danger" size="mini" @click="copyAllChoose()">复制{{ selectedVehicles.length }}辆</el-button>
                        <el-button class="mrgt5 mrgb5" size="mini" @click="clearAllChoose()">清空</el-button>
                    </div>
                </div>
            </div>
        </div>
        <!--指定点位配置-->
        <point-config :ref="refPointConfig" @refreshData="_updateData"></point-config>
        <!--查看点位的全部需求-->
        <point-demand :ref="refPointDemand"></point-demand>
    </div>
</template>

<script>
import * as funReport from "@/api/report"
import moment from 'moment'
import PointConfig from "./pointConfig"
import PointDemand from './components/PointDemand'

let dataVars = {
    map: null,
    polygonMap: null,
    parkingMarker: [],
    markers: null,
    pointMarkers: [],
    circleMarkers: [],
    orderMarkers: [], // 订单车辆点位
    infoWindow: null,
    mouseTool: null, // 鼠标绘制工具
    polygonObj: null,
    ruleTool: null
}
export default {
    name: "pageIntelligent",
    components: { PointConfig, PointDemand },
    data() {
        let that = this
        return {
            pageHeader: {
                desc: "查询配置点位车辆是否充足，给出建议补充和挪走的车辆数。"
            },
            refPointConfig: "refIntelligentToPointConfig",
            refPointDemand: "refIntelligentToPointDemand",
            listQuery: {
                area: "",
                beginDate: "",
                endDate: ""
            },
            activeIndex: "0",
            categoryAllText: "全部",
            coverMarker: null,
            coverPaths: [], // 服务区多边形点位
            isShowParking: true,
            parkings: [],
            pointTags: [],
            pointGroups: [],
            deviceItem: [],
            isScreen: false,
            selectedDate: moment(),
            selectedTime: [],
            spaceTime: 30, // 选择间隔时间30分钟
            pointTimes: [],
            selectedStartTime: "",
            isShowFold: true,
            centerPos: null,
            nextTitle: "", // 下一个时间段的标题，可判断是否有下一个时间段
            isOrderSwitchOpen: false, // 是否打开订单车辆点位的功能
            currentSelectedPointItem: null, // 记录当前选中的点位信息
            tableHighLightIndex: null,
            /**********车辆选点功能**********/
            isChooseVehicleOpen: false, // 选车开关，false可以移动地图
            chooseTypeArray: [1, 2],
            chooseType: null,
            isChooseVehicleStatus: true,
            polygonColor: "#1791fc",
            isShowSelectedFold: true,
            selectedVehicles: [],
            vehiclePointIcons: ['<img width="10" height="10" src="/static/images/map/mass0.png" />', '<img width="10" height="10" src="/static/images/map/point.png" />'],
            // vehiclePointIcons: ["<span class='point-red'></span>", "<span class='point-blue'></span>"],
            searchVehicleNumber: ""  // 快速搜索车辆号
        }
    },
    watch: {
        "$store.getters.serviceArea"(v) {
            this.mxIsSameActiveTabWithRoute(() => {
                this.initLoadData()
            })
        }
    },
    async mounted() {
        this.setSysPageHeader(this.pageHeader)
        this.setPointTimes()
        await this.initMap()
        await this.initLoadData()
        // this.openConfig()
        this.loadKeyDown()
        this.loadKeyUp()
    },
    unmounted() {
        dataVars.map?.destroy()
        document.removeEventListener("keydown")
        document.removeEventListener("keyup")
    },
    methods: {
        setPointTimes() {
            for (let i = 0; i < 24; i++) {
                let hour = i < 10 ? ("0" + i ) : i
                let time = moment().format(`YYYY-MM-DD ${hour}:00:00`)
                let sTime = moment(time).format("HH:mm")
                let eTime = moment(time).add(this.spaceTime, "m").format("HH:mm")
                this.pointTimes.push(sTime, eTime)
            }
        },
        setSelectedTime() {
            let psDate = ""
            let psTime = ""
            let peDate = ""
            let peTime = ""
            // 日期段
            if (this.selectedDate && moment(this.selectedDate).isValid()) {
                // 时间段
                if (this.selectedTime && this.selectedTime[0] && moment(this.selectedTime[0]).isValid()) {
                    psTime = moment(this.selectedTime[0]).format("HH:mm:ss")
                } else {
                    psTime = moment(this.selectedDate).format("00:00:00")
                }
                if (this.selectedTime && this.selectedTime[1] && moment(this.selectedTime[1]).isValid()) {
                    peTime = moment(this.selectedTime[1]).format("HH:mm:ss")
                } else {
                    peTime = moment(this.selectedDate).format("23:59:59")
                }
                psDate = moment(this.selectedDate).format(`YYYY-MM-DD ${psTime}`)
                peDate = moment(this.selectedDate).format(`YYYY-MM-DD ${peTime}`)
            }
            this.listQuery.beginDate = psDate
            this.listQuery.endDate = peDate
            this.selectedTime = [`${this.listQuery.beginDate}`, `${this.listQuery.endDate}`]
        },
        async initMap() {
            await window.$common.loadGaoDeMap({ plugins: ["AMap.MouseTool"] }, (Amap) => {
                // 生成地图
                this.initCreateMap()
            })
        },
        // 生成地图
        initCreateMap() {
            let zoom = 16
            dataVars.map = new AMap.Map("mapDeviceScreen", {  //设置地图容器id
                viewMode: "2D",    //是否为3D地图模式
                zoom: zoom,           //初始化地图级别
                center: [104.065861,30.657401], //初始化地图中心点位置
                // scrollWheel: false
            })
            dataVars.map.addControl(new AMap.ToolBar())
            dataVars.map.addControl(new AMap.Scale())
            // 创建鼠标绘制
            this.setMouseTools()
            // this.moveMap()
            // 右键
            this.setContextMenu()
        },
        setContextMenu() {
            // 创建右键
            let contextMenu = new AMap.ContextMenu()
            contextMenu.addItem("<i class='el-icon-plus'></i> 新增车辆", (e) => {
                this.chooseSwitch(true)
                this.chooseVehicleStatus(true)
                contextMenu.close()
            })
            contextMenu.addItem("<i class='el-icon-minus'></i> 移除车辆", (e) => {
                this.chooseSwitch(true)
                this.chooseVehicleStatus(false)
                contextMenu.close()
            })
            contextMenu.addItem("<i class='el-icon-menu'></i> 矩形框选", (e) => {
                this.chooseType = this.chooseTypeArray[0]
                this.chooseSwitch(true)
                contextMenu.close()
            })
            contextMenu.addItem("<i class='el-icon-bangzhu'></i> 圆形框选", (e) => {
                this.chooseType = this.chooseTypeArray[1]
                this.chooseSwitch(true)
                contextMenu.close()
            })
            contextMenu.addItem("<i class='el-icon-lock'></i> 结束框选", (e) => {
                this.chooseSwitch(false)
                contextMenu.close()
            })
            contextMenu.addItem("<i class='el-icon-c-scale-to-original'></i> 开始/清空测距", (e) => {
                if (!dataVars.ruleTool) {
                    dataVars.ruleTool = new AMap.MouseTool(dataVars.map)
                    dataVars.ruleTool.rule()
                } else {
                    dataVars.ruleTool.close(true)
                    dataVars.ruleTool = null
                }
                contextMenu.close()
            })
            contextMenu.addItem("<i class='el-icon-full-screen'></i> 全屏/取消全屏", (e) => {
                this.isScreen = !this.isScreen
                contextMenu.close()
            })
            contextMenu.addItem("<i class='el-icon-switch-button'></i> 关闭右键菜单", (e) => {
                contextMenu.close()
            })
            dataVars.map.on('rightclick', (e) => {
                contextMenu.open(dataVars.map, e.lnglat)
            })
        },
        // 地图移动，显示隐藏点位
        moveMap() {
            let _setTimeout = null
            let isMapMoving = false
            // 停止变动，显示海量点
            let stopMove = () => {
                _setTimeout && clearTimeout(_setTimeout)
                _setTimeout = setTimeout(() => {
                    console.log(isMapMoving)
                    if (isMapMoving) {
                        this.setAllOrderMarkers()
                        isMapMoving = false
                    }
                }, 600)
            }
            // 地图移动
            dataVars.map.on("mapmove", () => {
                isMapMoving = true
                _setTimeout && clearTimeout(_setTimeout)
                _setTimeout = null
                this.clearMarkers()
                this.clearOrderMarkers()
            })
            dataVars.map.on("moveend", () => {
                stopMove()
            })
            // 地图缩放
            dataVars.map.on("zoomstart", () => {
                isMapMoving = true
                _setTimeout && clearTimeout(_setTimeout)
                _setTimeout = null
                this.clearMarkers()
                this.clearOrderMarkers()
            })
            dataVars.map.on("zoomend", () => {
                stopMove()
            })
        },
        async initLoadData() {
            this.clearAllMarkers()
            this.activeIndex = "0"
            this.listQuery.area = this.$store.getters.serviceArea || ""
            this.nextTitle = ""
            window.$common.fullLoading()
            this.getCurrentAreaData()
            this.setPolygonContains()
            await this.getPackings()
            await this.getPointTags()
            await this.getDataList()
            // 设置分组
            this.setPointGroup()
            // 设置车辆点位marker
            this.setAllMarkers()
            // 设置指定点的点位
            this.setPointMarkers()
            // 设置指定点位覆盖的范围
            this.setPointCircle()
            // 创建窗体
            this.createinfoWindow()
            window.$common.closeFullLoading()
        },
        // 获取服务器的定位path信息
        getCurrentAreaData() {
            let areaName = this.$store.getters.serviceArea || ""
            let areaList = this.$store.getters.serviceAreas || []
            let areaItem = areaList.find(x => { return x.name === areaName })
            if (areaItem) {
                this.coverMarker = areaItem || {}
                this.coverPaths = areaItem.pointList || []
            }
        },
        // 设置多边形数据
        setPolygonContains() {
            dataVars.polygonMap && dataVars.map.remove(dataVars.polygonMap)
            let path = this.coverPaths
            if (path.length <= 0) {
                return false
            }
            dataVars.polygonMap = new AMap.Polygon({
                bubble: true,
                path: path,
                strokeColor: "#f56c6c", 
                strokeWeight: 3,
                strokeOpacity: 0.5,
                fillOpacity: 0,
                strokeStyle: 'dashed',
                strokeDasharray: [5, 5]
            })
            dataVars.map.add(dataVars.polygonMap)
            // 服务区有中心点则异动到服务区中心
            if (this.coverMarker && this.coverMarker.centerLng && this.coverMarker.centerLat) {
                let curLnglat = [this.coverMarker.centerLng, this.coverMarker.centerLat]
                this.moveToCenter({ lnglat: curLnglat })
            }
        },
        // 站点数据
        async getPackings() {
            this.parkings = []
            let area = this.$store.getters.serviceArea || ""
            await funReport.GetParkingLocations({ area }).then(response => {
                this.parkings = response
            })
            this.setPackingData()
        },
        // 设置站点信息
        setPackingData() {
            this.clearParking()
            if (this.isShowParking) {
                let markers = []
                let datas = JSON.parse(JSON.stringify(this.parkings))
                for (let i in datas) {
                    let item = datas[i]
                    let marker = new AMap.Polygon({
                        zIndex: 100,
                        bubble: true,
                        path: item.pointList,
                        strokeWeight: 1,
                        fillColor: "#f56c6c", // "#f56c6c",
                        fillOpacity: 0.2,
                        strokeColor: "#f56c6c", // "#f56c6c"
                        extData: item
                    })
                    marker.on("click", (ev) => {
                        let packItem = ev.target.getExtData()
                        funReport.GetParkingById({ id: packItem.id }).then(res => {
                            let content = `<div>
                                                <div class="txtClose" style="position: absolute; z-index: 100; top: -6px; right: -6px;"><i class="el-icon-error f16 col6"></i></div>
                                                <div class="f13" style="padding: 5px 8px 5px 5px;">
                                                    <div>站点名称：${res.name} <i class="el-icon-document-copy col_primary"></i></div>
                                                </div>
                                            </div>`
                            this.mxCommonMapTextInfo(dataVars.map, {
                                text: content,
                                position: [res.centerLng, res.centerLat]
                            }, () => {
                                try {
                                    window.navigator.clipboard.writeText(res.name).then(() => {
                                        this.successMsg("复制成功!")
                                    })
                                } catch(ex) {
                                    this.alert(res.name, "手动复制站点", {
                                        customClass: "wordbreakba"
                                    })
                                }
                            })
                        })
                    })
                    dataVars.parkingMarker.push(marker)
                    dataVars.map.add(marker)
                }
            }
        },
        async getPointTags() {
            await funReport.GetPointConfigCategories(this.listQuery).then(response => {
                this.pointTags = response
                this.pointTags.unshift(this.categoryAllText)
            })
        },
        async getDataList() {
            this.setSelectedTime()
            await funReport.GetDeviceScreen(this.listQuery).then(response => {
                this.deviceItem = response || {}
                this.deviceItem.time = moment(this.deviceItem.time).format("YYYY-MM-DD HH:mm:ss")
            })
        },
        // 分组
        setPointGroup() {
            let group = this.pointTags.map(x => {
                let pointItems = []
                if (this.deviceItem && this.deviceItem.pointData) {
                    if (x == this.categoryAllText) {
                        pointItems = this.deviceItem.pointData
                    } else {
                        pointItems = this.deviceItem.pointData.filter(m => m.category === x)
                    }
                }
                let temp = {
                    category: x,
                    items: pointItems.map(n => {
                        n.isSelected = false
                        n.diffValue = 0
                        if (n.nextDemandItem) {
                            n.diffValue = n.nextDemandItem.demandVehicleCount - n.vehicleCount
                            this.nextTitle = n.nextDemandItem.beginTime
                        }
                        return n
                    })
                }
                return temp
            })
            this.pointGroups = group
        },
        // 切换分类
        handleGroupClick(tab, event) {
            this.centerPos = null
            this.activeIndex = tab.index.toString()
            this.setPointMarkers()
            this.setPointCircle()
        },
        tableRowClassName({row, index}) {
            return row.isSelected ? "row-highlight" : ""
        },
        // 时间段选择
        selectTime(time) {
            this.selectedTime = []
            this.selectedStartTime = time
            let psTime = ""
            let peTime = ""
            if (this.selectedDate && moment(this.selectedDate).isValid()) {
                psTime = moment(this.selectedDate).format("YYYY-MM-DD " + time + ":00")
                peTime = moment(psTime).add(this.spaceTime, "m").format("YYYY-MM-DD HH:mm:00")
                this.selectedTime = [psTime, peTime]
                this.initLoadData()
            }
        },
        _updateData() {
            if (this.deviceItem && this.deviceItem.id) {
                funReport.UpdateDeviceScreen({ id: this.deviceItem.id }).then(res => {
                    this.centerPos = null
                    this.initLoadData()
                })
            } else {
                this.warningMsg("当前没有车辆数据!")
                return false
            }
        },
        // 设置车辆点marker
        setAllMarkers(datas) {
            let items = datas || this.deviceItem.gps || []
            let markers = []
            for (let i in items) {
                let item = items[i]
                let marker = new AMap.Marker({
                    position: [item.lng, item.lat],
                    anchor: "center",
                    content: this.vehiclePointIcons[1],
                    offset: new AMap.Pixel(0, 0),
                    extData: item
                })
                marker.on("click", (ev) => {
                    let target = ev.target.getExtData()
                    let pos = ev.target.getPosition()
                    dataVars.infoWindow.setContent(`<span style="padding: 0 10px 0 0;">车辆号：${target.carId}</span>`)
                    dataVars.infoWindow.open(dataVars.map, [pos.lng, pos.lat])
                })
                markers.push(marker)
            }
            if (items.length > 0) {
                dataVars.map.add(markers)
                dataVars.markers = markers
            }
        },
        setAllOrderMarkers() {
            if (!this.isOrderSwitchOpen) {
                return false
            }
            let row = this.currentSelectedPointItem
            if (row && row.nextDemandItem && row.nextDemandItem.sourceOrders) {
                // 设置订单车辆点位marker
                let items = row.nextDemandItem.sourceOrders || []
                let markers = []
                for (let i in items) {
                    let item = items[i]
                    let marker = new AMap.Marker({
                        position: [item.lng, item.lat],
                        anchor: "bottom-center",
                        content: `<img width="12" height="20" src="/static/images/map/poi-marker-yellow.png" />`,
                        offset: new AMap.Pixel(0, 3),
                        extData: item
                    })
                    marker.on("click", (ev) => {
                        let target = ev.target.getExtData()
                        let pos = ev.target.getPosition()
                        dataVars.infoWindow.setContent(`<span style="padding: 0 10px 0 0; line-height: 1.8;">订单编号：${target.orderId}<br />开始时间：${moment(target.startTime).format("YYYY-MM-DD HH:mm:ss")}</span>`)
                        dataVars.infoWindow.open(dataVars.map, [pos.lng, pos.lat])
                    })
                    markers.push(marker)
                }
                if (items.length > 0) {
                    dataVars.map.add(markers)
                    dataVars.orderMarkers = markers
                    return true
                }
            }
        },
        setPointMarkers() {
            this.clearPointMarkers()
            let acIndex = Number(this.activeIndex)
            let points = this.pointGroups[acIndex] && this.pointGroups[acIndex].items || []
            if (points.length <= 0) {
                return false
            }
            let markers = []
            for (let i in points) {
                let item = points[i]
                let marker = new AMap.Marker({
                    bubble: true,
                    position: [item.lng, item.lat],
                    offset: new AMap.Pixel(-20, -20),
                    zIndex: 20,
                    clickable: true,
                    content: this.getPointMarkerContent(item),
                    extData: item
                })
                marker.on("click", (ev) => {
                    let target = ev.target.getExtData()
                    let pos = ev.target.getPosition()
                    dataVars.infoWindow.setContent(`<span style="padding: 0 10px 0 0;">${target.name}</span>`)
                    dataVars.infoWindow.open(dataVars.map, [pos.lng, pos.lat])
                    this.moveToCenter({ lnglat: [target.lng, target.lat] })
                    this.selectGroupPoint(target)
                })
                markers.push(marker)
            }
            dataVars.map.add(markers)
            dataVars.pointMarkers = markers
            this.$forceUpdate()
        },
        // 设置指定点位的样式
        getPointMarkerContent(item) {
            let div = document.createElement('div')
            let Hue = 90
            if (item.diffValue > 0) {
                Hue = 0
            }
            let bgColor = 'hsla(' + Hue + ',100%,45%,0.7)'
            let fontColor = 'hsla(' + Hue + ',100%,100%,1)'
            let borderColor = 'hsla(' + Hue + ',100%,40%,1)'
            let shadowColor = 'hsla(' + Hue + ',100%,90%,1)'
            if (!item.diffValue) {
                bgColor = 'hsla(' + Hue + ',0%,85%,0.7)'
                fontColor = 'hsla(' + Hue + ',0%,100%,1)'
                borderColor = 'hsla(' + Hue + ',0%,70%,1)'
                shadowColor = 'hsla(' + Hue + ',0%,90%,1)'
            }
            div.style.backgroundColor = bgColor
            let size = 40;
            div.style.width = div.style.height = size + 'px'
            div.style.border = 'solid 1px ' + borderColor
            div.style.borderRadius = size / 2 + 'px'
            div.style.boxShadow = '0 0 5px ' + shadowColor
            div.innerHTML = item.diffValue > 0 ? `+${item.diffValue}` : item.diffValue // item.vehicleCount
            div.style.lineHeight = size + 'px'
            div.style.color = fontColor
            div.style.fontSize = '14px'
            div.style.textAlign = 'center'
            return div
        },
        // 设置覆盖范围
        setPointCircle() {
            this.clearCircleMarkers()
            let acIndex = Number(this.activeIndex)
            let points = this.pointGroups[acIndex] && this.pointGroups[acIndex].items || []
            if (points.length <= 0) {
                return false
            }
            let circles = []
            let fillColors = ["#1791fc", "#05ad80", "#9907f1", "#e0992d", "#2de0bc"]
            for (let i in points) {
                let item = points[i]
                let center = new AMap.LngLat(item.lng, item.lat);
                let circle = new AMap.Circle({
                    bubble: true,
                    center: center, //圆心
                    radius: item.checkDistance, //半径
                    borderWeight: 1,
                    strokeColor: "#FF33FF", 
                    strokeWeight: 4,
                    strokeOpacity: 0.2,
                    fillOpacity: 0.2,
                    strokeStyle: 'dashed',
                    strokeDasharray: [10, 10], 
                    // 线样式还支持 'dashed'
                    fillColor: fillColors[Math.floor(Math.random() * 5)]
                })
                circles.push(circle)
            }
            dataVars.map.add(circles)
            dataVars.circleMarkers = circles
        },
        // 创建信息窗体
        createinfoWindow() {
            dataVars.infoWindow = new AMap.InfoWindow({
                content: "",
                offset: [0, -20],
                autoMove: true
            })
        },
        clearAllMarkers() {
            this.centerPos = null
            this.currentSelectedPointItem = null
            this.clearParking()
            this.clearMarkers()
            this.clearOrderMarkers()
            this.clearPointMarkers()
            this.clearCircleMarkers()
        },
        clearParking() {
            for (let i in dataVars.parkingMarker) {
                dataVars.map.remove(dataVars.parkingMarker[i])
            }
            dataVars.parkingMarker = []
        },
        clearMarkers() {
            dataVars.markers && dataVars.map.remove(dataVars.markers)
            dataVars.markers = null
        },
        clearOrderMarkers() {
            dataVars.orderMarkers && dataVars.map.remove(dataVars.orderMarkers)
            dataVars.orderMarkers = null
        },
        clearPointMarkers() {
            dataVars.infoWindow && dataVars.infoWindow.close()
            dataVars.pointMarkers && dataVars.map.remove(dataVars.pointMarkers)
            dataVars.pointMarkers = null
        },
        clearCircleMarkers() {
            dataVars.circleMarkers && dataVars.map.remove(dataVars.circleMarkers)
            dataVars.circleMarkers = null
        },
        viewLocation(item) {
            this.alert(`
                覆盖范围：${item.checkDistance}米<br/>
                经度：${item.lng}<br/>
                纬度：${item.lat}`, `【${item.name}】经纬度`, {
                dangerouslyUseHTMLString: true
            })
        },
        rowClick(row, column, event, tag) {
            this.moveToCenter({ lnglat: [row.lng, row.lat] })
            this.selectGroupPoint(row)
            /* setTimeout(() => {
                let result = this.setAllOrderMarkers()
                if (result) {
                    // 判断点位个数
                    let index = tag.items.findIndex(x => x.name === row.name)
                    if (index !== -1) {
                        let count = 0
                        let curOrderMarkers = []
                        for (let i in dataVars.orderMarkers) {
                            let item = dataVars.orderMarkers[i]
                            let curOrderMarker = row.nextDemandItem.sourceOrders[i]
                            let pos = item.getPosition()
                            if (dataVars.circleMarkers[index].contains(pos)) {
                                count++
                                curOrderMarkers.push(curOrderMarker)
                            }
                        }
                    }
                }
            }, 600) */
        },
        moveToCenter(item) {
            // 清空订单车辆点位
            this.clearOrderMarkers()
            dataVars.map.setCenter(item.lnglat, false, 50)
        },
        selectGroupPoint(item) {
            this.currentSelectedPointItem = item
            // 反向定位选中的表数据
            let curGroups = this.pointGroups[this.activeIndex]
            curGroups.items = curGroups.items.map(x => {
                x.isSelected = false
                if (item.name === x.name) {
                    x.isSelected = true
                }
                return x
            })
            setTimeout(() => {
                this.setAllOrderMarkers()
            }, 100)
        },
        openConfig() {
            this.$refs[this.refPointConfig].open()
        },
        orderSwitch() {
            this.isOrderSwitchOpen = !this.isOrderSwitchOpen
            if (this.isOrderSwitchOpen) {
                this.setAllOrderMarkers()
            } else {
                this.clearOrderMarkers()
            }
        },
        getCurrentDemand(row) {
            let params = {
                area: this.listQuery.area,
                pointName: row.name
            }
            funReport.GetPointConfigDemands(params).then(res => {
                if (res && res.length > 0) {
                    this.$refs[this.refPointDemand].open(res[0])
                }
            })
        },
        /************鼠标绘制选点************/
        // 创建鼠标绘制
        setMouseTools() {
            dataVars.map.on("mousedown", (e) => {
                if (e.originEvent.button === 2) {
                    // this.chooseVehicleStatus()
                    // this.chooseSwitch()
                }
            })
            dataVars.mouseTool = new AMap.MouseTool(dataVars.map)
            dataVars.mouseTool.on("draw", (event) => {
                dataVars.polygonObj = event.obj
                // event.obj 为绘制出来的覆盖物对象
                for (let i in dataVars.markers) {
                    let item = dataVars.markers[i]
                    let target = item.getExtData()
                    let pos = item.getPosition()
                    if (dataVars.polygonObj.contains(pos)) {
                        if (this.isChooseVehicleStatus) {
                            item.setContent(this.vehiclePointIcons[0])
                            let temp = this.selectedVehicles.find(x => x.carId === target.carId)
                            if (!temp) {
                                this.selectedVehicles.push(target)
                            }
                        } else {
                            item.setContent(this.vehiclePointIcons[1])
                            let tempIndex = this.selectedVehicles.findIndex(x => x.carId === target.carId)
                            if (tempIndex !== -1) {
                                this.selectedVehicles.splice(tempIndex, 1)
                            }
                        }
                    }
                }
                dataVars.map.remove(dataVars.polygonObj)
            })
        },
        // 删除车辆
        deleteChoose(row, index) {
            for (let i in dataVars.markers) {
                let item = dataVars.markers[i]
                let target = item.getExtData()
                if (row.carId === target.carId) {
                    item.setContent(this.vehiclePointIcons[1])
                    break
                }
            }
            this.selectedVehicles.splice(index, 1)
        },
        // 复制车辆
        copyAllChoose() {
            if (this.selectedVehicles.length <= 0) {
                this.warningMsg("没有选择车辆!")
                return false
            }
            let arr = this.selectedVehicles.map(x => x.carId)
            let txt = arr.join(";")
            try {
                window.navigator.clipboard.writeText(txt).then(() => {
                    this.successMsg("复制成功!")
                })
            } catch(ex) {
                this.alert(txt, "手动复制车辆号", {
                    customClass: "wordbreakba"
                })
            }
        },
        // 清空车辆
        clearAllChoose() {
            this.confirm("确定要清空选择的车辆吗?").then(() => {
                for (let i in dataVars.markers) {
                    let item = dataVars.markers[i]
                    let target = item.getExtData()
                    item.setContent(this.vehiclePointIcons[1])
                }
                this.selectedVehicles = []
            })
        },
        chooseSwitch(isOpen) {
            if (isOpen !== undefined) {
                this.isChooseVehicleOpen = isOpen
            } else {
                this.isChooseVehicleOpen = !this.isChooseVehicleOpen
            }
            if (!this.isChooseVehicleOpen) {
                dataVars.mouseTool && dataVars.mouseTool.close(true)
            } else {
                this.chooseVehicleType(this.chooseType)
            }
        },
        chooseVehicleType(type) {
            // 先移除之前的选框对象
            dataVars.polygonObj && dataVars.map.remove(dataVars.polygonObj)
            this.polygonColor = this.isChooseVehicleStatus ? "#1791fc" : "#f56c6c"
            this.chooseType = type || this.chooseTypeArray[0]
            let options = {
                strokeColor: this.polygonColor, //轮廓线颜色
                strokeOpacity: 0.3, //轮廓线透明度
                strokeWeight: 2, //轮廓线宽度
                fillColor: this.polygonColor, //多边形填充颜色
                fillOpacity: 0.6, //多边形填充透明度
                strokeStyle: "solid", //线样式还支持 'dashed'
            }
            if (this.chooseType === this.chooseTypeArray[0]) {
                dataVars.mouseTool.rectangle(options)
            } else if (this.chooseType === this.chooseTypeArray[1]) {
                dataVars.mouseTool.circle(options)
            }
        },
        chooseVehicleStatus(isAdd) {
            if (isAdd !== undefined) {
                this.isChooseVehicleStatus = isAdd
            } else {
                this.isChooseVehicleStatus = !this.isChooseVehicleStatus
            }
            this.chooseVehicleType(this.chooseType)
        },
        loadKeyDown() {
            document.addEventListener("keydown", (obj) => {
                let key = obj.key
                if (key === "Control") {
                    this.chooseSwitch(true)
                    this.chooseVehicleStatus(true)
                } else if (key === "Alt") {
                    this.chooseSwitch(true)
                    this.chooseVehicleStatus(false)
                }
            })
        },
        loadKeyUp() {
            document.addEventListener("keyup", (obj) => {
                let key = obj.key
                if (key === "Control") {
                    this.chooseSwitch(false)
                } else if (key === "Alt") {
                    this.chooseSwitch(false)
                }
            })
        },
        // 搜索车辆
        searchVehicle() {
            let temp = dataVars.markers.find(ev => {
                let target = ev.getExtData()
                return target.carId === this.searchVehicleNumber
            })
            if (temp) {
                let target = temp.getExtData()
                let pos = temp.getPosition()
                dataVars.infoWindow.setContent(`<span style="padding: 0 10px 0 0;">车辆号：${target.carId}</span>`)
                dataVars.infoWindow.open(dataVars.map, [pos.lng, pos.lat])
                dataVars.map.setCenter([pos.lng, pos.lat], null, 100)
                this.searchVehicleNumber = ""
            }
        }
    }
}
</script>